import { motion } from "framer-motion";

export const ScaleReveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36, scale: 0.98 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-18% 0px" }}
    transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
